import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import apiFetch from "@wordpress/api-fetch";
import Cookies from 'js-cookie';

const RedirectModalWrapper = ({pageId, pageUrl}) => {
  const apiTarget = "/wp-json/headland/v1/redirect"

  const [redirectInfo, setRedirectInfo] = React.useState({
    redirectable: false,
    redirectUrl: "",
    isoCode: "GB"
  });
  
  const [showModal, setShowModal] = React.useState(Cookies.get("showModal") ? (Cookies.get("showModal") === "true") : true);

  useEffect(() => {
    if (showModal) {
      apiFetch({
        path: apiTarget,
        method: "POST",
        data: {
          pageId,
          pageUrl
        }
      })
      .then((response) => {
        setRedirectInfo(response)
      })
      .catch((error) => {
        console.error(error);
      });
    }
  }, []);

  const renderContent = () => {
    let modalText = null;
    let redirectText = null;
    if (redirectInfo.isoCode === "GB") {
      modalText = "It looks like you are in the UK"
      redirectText = "UK Website"
    } else {
      modalText = "It looks like you are outside the UK";
      redirectText = "International Website"
    }

    return (
      <div className={"modal__content"}>
        <p className={"modal__text"}>{modalText}</p>
        <div className={"modal__controls"}>
          <a className={"btn btn--primary"} href={redirectInfo.redirectUrl} onClick={(event) => {
            event.preventDefault();
            Cookies.set("showModal", false);
            window.location.href = event.target.href;
            setShowModal(false);
          }}>
            {redirectText}
          </a>
          <button className={"btn btn-black"} onClick={() => {
            Cookies.set("showModal", false);
            setShowModal(false);
          }}>
            Stay
          </button>
        </div>
      </div>
    )
  }

  return (
    <div>
      <dialog className={"modal modal--redirect"} open={redirectInfo.redirectable && showModal}>
        <div className="modal__overlay">
          {renderContent()}
        </div>
      </dialog>
    </div>
  )
}

RedirectModalWrapper.propTypes = {
  pageId: PropTypes.number,
  pageUrl: PropTypes.string
}

export default RedirectModalWrapper;
